<template>
    <div class="row">
      <div class="col-sm-12">
        <img src="~assets/alerts/mockup-alerts.png">
      </div>
    </div>
</template>
<script>
import UserCard from "./UserCard.vue";
export default {
  components: {
    UserCard
  }
};
</script>
<style lang='scss' scoped>
img {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/js/components/engagement/alerts/AlertHome.vue